module.exports = __webpack_public_path__ + "img/fans-attendance.5a103528.svg";